import React from 'react';

import WealthTechApp from 'WealthTechApp';

import { AppProviders } from 'providers';

function App() {
  return (
    <AppProviders>
      <WealthTechApp />
    </AppProviders>
  );
}

export default App;
